import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import "../../sass/components/PillTabToggle.scss";

export default function PillTabToggle({state, dispatch, tabTitles}) {
    return (
        <Tab.Container id="pill-tab-toggle"
                       defaultActiveKey={state.toggleValue === 'monthly' ? "0" : state.toggleValue === 'yearly' ? "1" : "2" }>
            <Nav variant="pills">
                {tabTitles.map((title, index) => {
                    return <Nav.Item key={index}>
                        <Nav.Link eventKey={index}
                                  data-qa={`${title.toLowerCase()}-pill-toggle`}
                                  onClick={(e) => {
                                      if(e.target.textContent === "Mensual" || e.target.textContent === "Monthly") {
                                          dispatch({ type: "toggleValue", payload: { toggleValue: "monthly" }});
                                      } else if(e.target.textContent === "Anual" || e.target.textContent === "Yearly") {
                                          dispatch({ type: "toggleValue", payload: { toggleValue: "yearly" }});
                                      } else if(e.target.textContent === "3 Años" || e.target.textContent === "3 Year") {
                                          dispatch({ type: "toggleValue", payload: { toggleValue: "thirtysixmonths" }});
                                      }
                                  }}>
                            {title}
                        </Nav.Link>
                    </Nav.Item>
                })}
            </Nav>
        </Tab.Container>
    )
}
